import { render, staticRenderFns } from "./openMember.vue?vue&type=template&id=2901496f&scoped=true&"
import script from "./openMember.vue?vue&type=script&lang=js&"
export * from "./openMember.vue?vue&type=script&lang=js&"
import style0 from "./openMember.vue?vue&type=style&index=0&id=2901496f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2901496f",
  null
  
)

export default component.exports